import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

class Intro extends React.Component {
  render(){
    const { parents } = this.props;
    const now = parents[parents.length - 1];
    return (
      <div id="contentintro">
        <Breadcrumb>
          { parents && parents.map((dataItem, index) => {
            return (
              <Breadcrumb.Item key={'bread' + dataItem.key}>
                {
                  dataItem.sub ?
                  <Link to={ dataItem.key }>
                    <span>{ dataItem.title }</span>
                  </Link> :
                  <span>{ dataItem.title }</span>
                }
              </Breadcrumb.Item>
            )
          })}
        </Breadcrumb>
        <div id="contentTitle">
          { <span>{ now.title }<span className="intro-tip">{ now.tip ? "（" + now.tip + "）" : "" }</span></span> }
        </div>
      </div>
    )
  }
}
export default Intro;



// WEBPACK FOOTER //
// ./src/index/intro.js